import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../auth/AuthHandler";
import {
  TopButtons,
  VersionCard,
  Switcher,
  TitleCard,
} from "../../../components/index";
import {
  ReleaseTrackerDataService,
  softwareIdToName,
} from "../../../data/ReleaseTrackerDataService";
import { useBreadcrumb } from "../../../hooks/useBreadcrumb";

export default function Versions({ match }) {
  const authCtx = useContext(AuthContext);
  const { url } = match.params;

  const [softwarePackage, setSoftwarePackage] = useState(null);
  const [softwareVersions, setSoftwareVersions] = useState([]);
  const [show, setShow] = useState(false);
  const [key, setKey] = useState("");
  const [selected, setSelected] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");

  // Update breadcrumbs when softwarePackage loads or url changes
  useBreadcrumb(
    softwarePackage
      ? [
          { label: "Home", path: "/" },
          { label: "Software", path: "/software" },
          { label: softwarePackage.Name },
        ]
      : [
          { label: "Home", path: "/" },
          { label: "Software", path: "/software" },
          { label: url },
        ],
    [url, softwarePackage],
  );

  // Initial load and when url changes
  useEffect(() => {
    const relTrackerService = new ReleaseTrackerDataService(authCtx);

    relTrackerService
      .getSoftwarePackage(softwareIdToName(url))
      .then((data) => {
        setSoftwarePackage(data);

        // Check query params for tab selection
        const params = new URLSearchParams(window.location.search);
        const tabFromUrl = params.get("tab");

        // If tab param exists and data has versions, find and load that version
        if (tabFromUrl && data.MayorVersions && data.MayorVersions.length > 0) {
          const selectedVersion = data.MayorVersions.find(
            (item) => item.MayorVersion === tabFromUrl,
          );

          if (selectedVersion) {
            getVersions(selectedVersion);
            return; // exit early, getVersions will set selected/selectedItem
          }
        }

        // Default: select first version
        if (data.MayorVersions && data.MayorVersions.length > 0) {
          getVersions(data.MayorVersions[0]);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, authCtx]);

  const getVersions = (keyData) => {
    const relTrackerService = new ReleaseTrackerDataService(authCtx);

    setSoftwareVersions([]);
    setSelected(true);
    setShow(true);
    setKey(keyData);
    setSelectedItem("V" + keyData.MayorVersion);

    // download version details
    relTrackerService
      .getSoftwareVersions(softwareIdToName(url), keyData.MayorVersion)
      .then((data) => {
        setSoftwareVersions(data);
        setSelected(true);
        setShow(true);
        setKey(keyData);
        setSelectedItem("V" + keyData.MayorVersion);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div className="versions">
      <TopButtons />
      <div className="titleSection">
        <TitleCard
          img={require("./../../../assets/svg/" + url + ".svg").default}
        />
        {softwarePackage && <h3>{softwarePackage.Name}</h3>}
      </div>
      <div className="switcher-container">
        <p>Select version package</p>
        <div className="switcher">
          <div className="switcher-scroll">
            {softwarePackage &&
              softwarePackage.MayorVersions.map((keyData) => (
                <Switcher
                  key={keyData.MayorVersion}
                  content={"V" + keyData.MayorVersion}
                  selected={selected}
                  selectedItem={selectedItem}
                  onClick={() => getVersions(keyData)}
                />
              ))}
          </div>
        </div>
      </div>
      {show && (
        <div className="cards">
          {softwareVersions.map((value) => (
            <VersionCard
              key={value.Code}
              title={value.Code}
              version={{
                pathname:
                  "/software/" +
                  url +
                  "/" +
                  key.MayorVersion +
                  "/" +
                  value.Code,
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
